/*
 * @Description: 海报路由列表
 * @Author: xzp
 * @Date: 2021-6-16 11:00:00
 * @LastEditTime: 2023-11-29 14:30:22
 * @LastEditors: sunbingqing
 */
export default {
  routes: [
    {
      path: "/poster/share",
      name: "poster_share",
      component: () => import("@/module/poster/SharePoster.vue"),
      meta: {
        title: "海报分享",
        keepAlive: false,
        logined: true
      }
    },{
      path: "/new/poster/share",
      name: "new_poster_share",
      component: () => import("@/module/poster/NewSharePoster.vue"),
      meta: {
        title: "海报分享",
        keepAlive: false,
        logined: true
      }
    }
  ]
};


// WEBPACK FOOTER //
// ./src/router/Poster.js